export default function Privacy() {
  return (
    <main className="page">
      <div className="page-content">
        <div className="card">
          <h1 className="card-title">Privacy Policy</h1>
          <p className="card-subtitle">Last Updated: 11/19/2025</p>

          <section className="card-section">
            <p>
              Ban Appeals (&quot;we,&quot; &quot;our,&quot; &quot;us&quot;) operates a Discord bot and the Ban Appeals
              website (banappeals.org). This Privacy Policy explains how we collect, use, and protect your information
              when you use our bot or website.
            </p>
            <p>
              By using the Ban Appeals bot or website, you agree to the practices described in this Privacy Policy.
            </p>
          </section>

          <section className="card-section">
            <h2>1. Information We Collect</h2>

            <h3>1.1 Through the Discord Bot</h3>
            <ul>
              <li>
                <strong>Guild (Server) Information:</strong> Server ID, server name, configuration settings, enabled
                features, and appeal-related options.
              </li>
              <li>
                <strong>User Information (Limited):</strong> Discord user IDs and usernames as needed for appeal
                submissions, moderation tracking, and authentication. We do not store general message content outside
                of the appeals process.
              </li>
              <li>
                <strong>Appeal Information:</strong> Appeal text, timestamps, decisions, and staff responses.
              </li>
              <li>
                <strong>Technical Metadata:</strong> Logs and timestamps needed for debugging, security, and reliability.
              </li>
            </ul>

            <h3>1.2 Through the Website</h3>
            <ul>
              <li>
                <strong>Authentication Data (via Discord OAuth):</strong> Discord user ID, username, avatar, and a list
                of servers you manage or belong to (only as needed to verify permissions and show relevant data).
              </li>
              <li>
                <strong>Form Submissions:</strong> Appeal forms, server configuration changes, and support or premium
                inquiries that you submit.
              </li>
              <li>
                <strong>Technical Information:</strong> IP address, browser type, device information, and cookies
                required for login/session management and security.
              </li>
            </ul>
            <p>
              We do not collect your private Discord messages, password, or other sensitive Discord account details.
            </p>
          </section>

          <section className="card-section">
            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect strictly to operate and improve Ban Appeals, including to:</p>
            <ul>
              <li>Process and manage ban appeals for participating Discord servers.</li>
              <li>Authenticate users via Discord OAuth and show relevant servers and appeals.</li>
              <li>Allow server administrators to configure appeal settings and preferences.</li>
              <li>Maintain security, prevent abuse, and debug technical issues.</li>
              <li>Improve features, performance, and user experience.</li>
              <li>Respond to support requests and questions.</li>
            </ul>
            <p>
              We <strong>do not</strong> sell your personal information, and we <strong>do not</strong> share it with
              third parties for advertising or marketing purposes.
            </p>
          </section>

          <section className="card-section">
            <h2>3. Data Storage &amp; Security</h2>
            <ul>
              <li>
                Data is stored using industry-standard security practices on our infrastructure and hosting providers.
              </li>
              <li>
                Access to databases and configuration is restricted to authorized systems and administrators only.
              </li>
              <li>
                We store only the minimum amount of data required for the bot and website to function properly.
              </li>
            </ul>
          </section>

          <section className="card-section">
            <h2>4. Data Retention</h2>
            <ul>
              <li>Appeals and related records are stored as long as they are needed by the server&apos;s staff.</li>
              <li>
                Guild configuration data is retained while the bot remains in the server and may be removed after the
                bot is removed.
              </li>
              <li>
                You may contact us to request deletion of personal data associated with your Discord ID where
                technically and legally possible.
              </li>
            </ul>
          </section>

          <section className="card-section">
            <h2>5. Data Sharing</h2>
            <p>We only share data in limited circumstances:</p>
            <ul>
              <li>
                <strong>Discord:</strong> We interact with Discord&apos;s API to operate the bot and handle OAuth
                authentication.
              </li>
              <li>
                <strong>Hosting/Infrastructure Providers:</strong> Such as cloud servers and databases used to host the
                bot, website, and data.
              </li>
              <li>
                <strong>Legal Requirements:</strong> If required to comply with applicable laws, regulations, or valid
                legal requests.
              </li>
            </ul>
            <p>We do not otherwise share or sell user information.</p>
          </section>

          <section className="card-section">
            <h2>6. Cookies</h2>
            <p>Banappeals.org uses only essential cookies, such as:</p>
            <ul>
              <li>Session cookies to keep you logged in and secure.</li>
              <li>CSRF protection cookies to help prevent malicious requests.</li>
              <li>Preference cookies (for example, light/dark mode) where applicable.</li>
            </ul>
            <p>We do not use cookies for targeted advertising.</p>
          </section>

          <section className="card-section">
            <h2>7. Children&apos;s Privacy</h2>
            <p>
              Ban Appeals is not intended for children under the age of 13. We do not knowingly collect information from
              children. If we become aware that data from a child under 13 has been collected, we will delete it.
            </p>
          </section>

          <section className="card-section">
            <h2>8. Your Rights</h2>
            <p>Depending on your location, you may have the right to:</p>
            <ul>
              <li>Request access to the data we store about you.</li>
              <li>Request correction or deletion of your personal data.</li>
              <li>Ask questions about how your data is collected and used.</li>
            </ul>
            <p>
              To exercise these rights, contact us using the methods listed below. We may need to verify your identity
              via your Discord account.
            </p>
          </section>

          <section className="card-section">
            <h2>9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. When we do, we will update the &quot;Last
              Updated&quot; date at the top of this page. Continued use of the bot or website after changes are posted
              means you accept the updated policy.
            </p>
          </section>

          <section className="card-section">
            <h2>10. Contact Us</h2>
            <p>
              If you have questions or requests related to this Privacy Policy or your data, you can contact us through:
            </p>
            <ul>
              <li>Support Server: <a href="/support" target="_blank" rel="noopener noreferrer">Click to join</a></li>
              <li>Email: <a href="mailto:support@banappeals.org" target="_blank" rel="noopener noreferrer">support@banappeals.org</a></li>
            </ul>
          </section>
        </div>
      </div>
    </main>
  );
}
